const freeEmailProviders = new Set([
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "aol.com",
  "zoho.com",
  "icloud.com",
  "protonmail.com",
  "gmx.com",
  "yandex.com",
  "mail.com",
  "tutanota.com",
  "fastmail.com",
  "mail.ru",
  "lycos.com",
  "inbox.com",
  "rediff.com",
  "naver.com",
  "163.com",
  "qq.com",
  "seznam.cz",
  "web.de",
  "libero.it",
  "orange.fr",
  "laposte.net",
  "sapo.pt",
  "mailfence.com",
  "posteo.de",
  "startmail.com",
  "mailinator.com",
  "10minutemail.com",
  "guerrillamail.com",
  "temp-mail.org",
  "throwawaymail.com",
]);

const competitorDomains = new Set([
  "acoustic.com",
  "actito.com",
  "activecampaign.com",
  "adobe.com",
  "airship.com",
  "apsis.com",
  "attentive.com",
  "batch.com",
  "bdash-marketing.com",
  "bigin.io",
  "bloomreach.com",
  "blueshift.com",
  "brevo.com",
  "clevertap.com",
  "cordial.com",
  "customer.io",
  "dfinery.io",
  "dotdigital.com",
  "emarsys.com",
  "google.com",
  "groobee.com",
  "hubspot.com",
  "infobip.com",
  "intercom.com",
  "iterable.com",
  "karte.io",
  "klaviyo.com",
  "localytics.com",
  "mailchimp.com",
  "mailgun.com",
  "meetmarigold.com",
  "memberson.com",
  "messagegears.com",
  "microsoft.com",
  "mixpanel.com",
  "moengage.com",
  "netcorecloud.com",
  "obzen.com",
  "onesignal.com",
  "optimove.com",
  "ortto.com",
  "punchh.com",
  "repro.io",
  "retentionscience.com",
  "salesforce.com",
  "sendinblue.com",
  "simondata.com",
  "solutionsbytext.com",
  "swrve.com",
  "twilio.com",
  "uplandsoftware.com",
  "useinsider.com",
  "zetaglobal.com",
  "bird.com",
  "mapp.com",
  "aleitar.com",
  "nestvia.com",
]);

const partnerDomains = new Set([
  "1hanover.co",
  "4digitalconsulting.com",
  "5and5.com",
  "ab180.co",
  "abeam.com",
  "aboutpet.co.kr",
  "acceleration.biz",
  "accenture.com",
  "accuweather.com",
  "action-rocket.co",
  "actioniq.com",
  "actionrocket.co",
  "acxiom.com",
  "acxiomllc.com",
  "ada-asia.com",
  "ada.support",
  "adasight.com",
  "addvanto.ch",
  "adikteev.com",
  "adjust.com",
  "admazing.co",
  "advalyze.de",
  "afdigital.com",
  "affluxo.com",
  "ahieh.com",
  "aimia.com",
  "aionicdigital.com",
  "airbyte.io",
  "akampus.com",
  "akcelo.com",
  "akqa.com",
  "alchemyworx.com",
  "alite-international.com",
  "allsetcomunicacao.com.br",
  "almaviacx.com",
  "alpaco.email",
  "altudo.co",
  "amazon.co.uk",
  "amazon.de",
  "amazon.es",
  "amazon.fr",
  "amperity.com",
  "amplitude.com",
  "antavo.com",
  "aofl.com",
  "apadmi.com",
  "appgrowthnetwork.com",
  "appknot.com",
  "applydigital.co",
  "applydigital.com",
  "appsamurai.com",
  "appsflyer.com",
  "aquient.asia",
  "arena-ai.com",
  "armadillocrm.com",
  "ask-digitalservices.com",
  "attributics.com",
  "authkey.io",
  "avaus.com",
  "avexdesigns.com",
  "aymcommerce.com",
  "bamstrategy.com",
  "barkleyus.com",
  "bcg.com",
  "bcgdv.com",
  "be2see.co.il",
  "beet.se",
  "belltech.la",
  "bemyfriends.com",
  "benluong.com",
  "biggroup.co.uk",
  "bildungdata.com",
  "bitbang.com",
  "blastam.com",
  "blastx.com",
  "blend360.com",
  "blendmedia.co.id",
  "blueberrywave.com",
  "bluedot.io",
  "bluelabellabs.com",
  "blueoshan.com",
  "blusnow.com",
  "bmomedia.co",
  "boldramp.com",
  "bottlerocketstudios.com",
  "bounteous.com",
  "bowerhousedigital.com.au",
  "braincommerce.com",
  "branch.io",
  "branchmetrics.io",
  "brandcontentstrategy.com",
  "bravelabs.be",
  "brcg.co",
  "bright.haus",
  "brillio.com",
  "buytechbetter.com",
  "caci.co.uk",
  "capgemini.com",
  "captv.co.kr",
  "carbonfive.com",
  "catchdesign.co.nz",
  "certona.com",
  "cgi.com",
  "chartis.io",
  "cheil.com",
  "chepnetwork.com",
  "cintellic.com",
  "cj.net",
  "clarisights.com",
  "classmethod.jp",
  "cleargoals.com",
  "clydegolden.com",
  "codecrew.us",
  "codeworldwide.com",
  "cognifide.com",
  "cognizant.com",
  "coinone.com",
  "comet.cx",
  "constellationagency.com",
  "constellationgroupe.com",
  "consultmyapp.com",
  "contentsquare.com",
  "continuumglobal.com",
  "convz.com",
  "copypastd.com",
  "covalentmarketing.com",
  "credera.co.uk",
  "credera.com",
  "credera.com.au",
  "crossingminds.com",
  "crowdin.com",
  "crsd.de",
  "customlytics.com",
  "cyberagent.co.jp",
  "d2c.tw",
  "d3-nyc.com",
  "daangn.com",
  "dac.co.jp",
  "data-axle.com",
  "databricks.com",
  "datagrail.io",
  "datamine.com",
  "datasentics.com",
  "dearone.io",
  "degdigital.com",
  "deloitte.ca",
  "deloitte.com",
  "deloitte.com.au",
  "deloitte.fr",
  "deloitte.no",
  "deloittece.com",
  "demandpdx.com",
  "demeterict.com",
  "dentsu.com",
  "dentsudigital.co.jp",
  "digioh.com",
  "digitalalchemy.asia",
  "digitalalchemy.com.au",
  "digitalidentity.co.jp",
  "digitallymeasured.co",
  "digitalresponse.es",
  "digitalshift.co.jp",
  "digitas.com",
  "digitaweb.com",
  "directagents.com",
  "directus.co.jp",
  "dividebyzero.com.au",
  "dmit.co.th",
  "dramancompany.com",
  "dunamu.com",
  "dwarf.dk",
  "dynamicyield.com",
  "dyspatch.io",
  "e-cens.com",
  "earnest.com",
  "eclerx.com",
  "edit.co.uk",
  "edume.com",
  "ekino.com",
  "elitesem.com",
  "emailaptitude.com",
  "emailmonks.net",
  "ematicsolutions.com",
  "emea.merkleinc.com",
  "endava.com",
  "engelworks.co.uk",
  "enterprisemartech.com",
  "epam.com",
  "epopsoft.kr",
  "epsilon.com",
  "esagegroup.com",
  "etnetera.cz",
  "etribes.de",
  "ex-ture.jp",
  "extole.com",
  "falcon-agency.com",
  "fiatgrowth.com",
  "finda.co.kr",
  "five.agency",
  "fivetran.com",
  "flywheelsoftware.com",
  "fornowmarketing.com",
  "foursquare.com",
  "frankinsense.co.za",
  "fueled.com",
  "fuse.cx",
  "galepartners.com",
  "getcensus.com",
  "globant.com",
  "gonift.com",
  "goodhumans.agency",
  "goodkarma.nyc",
  "graftedgrowth.com",
  "gretrix.com",
  "grey.com",
  "grouparoo.com",
  "growthdynamix.io",
  "growthinstincts.com",
  "growthpractice.com",
  "habitfactory.co",
  "hakuhodo-ms.co.jp",
  "hakuhodo.co.jp",
  "halfords.co.uk",
  "hanssem.com",
  "happymarketer.com",
  "havashelia.com",
  "hawkemedia.com",
  "heady.io",
  "heap.io",
  "heapanalytics.com",
  "helloworld.com",
  "hexdon.com",
  "hightouch.io",
  "hippocampus.me",
  "horizonmedia.com",
  "hs2solutions.com",
  "hugeinc.com",
  "human37.com",
  "ii.co.th",
  "iixp.co.th",
  "img.com",
  "inboxmonster.com",
  "incudata.co.jp",
  "indicia.com",
  "indicia.konicaminolta.com",
  "inkit.io",
  "inlight.com.au",
  "innovacx.com",
  "insidelabs.tech",
  "inspeerity.com",
  "intert.co.kr",
  "intive.com",
  "ioocx.com",
  "iprospect.com",
  "iris-worldwide.com",
  "isobar.com",
  "iteratehq.com",
  "ivegroup.com.au",
  "ix.co",
  "jacobsonrost.com",
  "jakala.com",
  "jampp.com",
  "jebbit.com",
  "jellyfish.com",
  "jp.nttdata.com",
  "judo.app",
  "kaplan.se",
  "karix.com",
  "kcd.co.kr",
  "ketch.com",
  "kggroup.co.kr",
  "kissolutions.tech",
  "knak.com",
  "knowndecimal.com",
  "kochava.com",
  "kognitiv.com",
  "komo.tech",
  "konradgroup.com",
  "kpmg.com",
  "kreis1.com",
  "kubit.co",
  "l-s.com",
  "lamarkmedia.com",
  "laughlin.com",
  "lavabeam.com",
  "leadfront.se",
  "levana.io",
  "levdigital.com",
  "leverup.io",
  "lexer.io",
  "liftigniter.com",
  "listerdigital.com",
  "listertechnologies.com",
  "lob.com",
  "locationvalue.com",
  "lokalise.com",
  "loplat.com",
  "lotrean.com.au",
  "lunarsolargroup.com",
  "luxidgroup.com",
  "lytics.com",
  "mackevision.com",
  "madup.com",
  "mailbakery.com",
  "mammothgrowth.com",
  "marketdata.com.br",
  "marketingdecisions.com.au",
  "marketingmedia.co",
  "martinee.io",
  "massiveinsights.com",
  "massiverocket.com",
  "materialplus.io",
  "mcgaw.io",
  "mckinsey.com",
  "mcsaatchi.com",
  "mediacom.com",
  "mediamenu.ee",
  "mediamint.com",
  "mediamonks.com",
  "mediarithmics.com",
  "menu.app",
  "merkle.com",
  "merklecxm.com",
  "merkleinc.com",
  "merkleinc.onmicrosoft.com",
  "metarouter.io",
  "metric-studio.com",
  "mfec.co.th",
  "mhdigitalgroup.com",
  "microsoft.com",
  "miltton.com",
  "miltton.se",
  "mindshareworld.com",
  "ministryofcrm.com",
  "mintel.tech",
  "mirumagency.com",
  "mirumindia.com",
  "mixpanel.com",
  "mkr.agency",
  "mobikasa.com",
  "mobilegrowth.io",
  "mobtimizers.com",
  "modusagency.com",
  "montivory.com",
  "motam.co.nz",
  "movableink.com",
  "mozartdata.com",
  "mparticle.com",
  "mrm.com",
  "mscale.io",
  "mustit.co.kr",
  "mz.co.kr",
  "namics.com",
  "neohub.com.tr",
  "neudesic.com",
  "neuronics.bbdo.es",
  "nevskycollective.com",
  "nexla.com",
  "nexum.com",
  "nicepeopleatwork.com",
  "nolimitemail.com",
  "notablegrowth.com",
  "novoda.com",
  "nthstar.co",
  "nttdata.com",
  "octolis.com",
  "offerfit.ai",
  "ogilvy.co.za",
  "ogilvy.com",
  "oliver.agency",
  "omd.com",
  "omegacrmconsulting.com",
  "omniarch.se",
  "omnifactors.com",
  "omnigon.com",
  "omtera.com",
  "onemarketing.dk",
  "onetrust.com",
  "optilyz.com",
  "organic.com",
  "origin-digital.com",
  "orium.com",
  "ottomate.co",
  "outliant.com",
  "overdose.digital",
  "paiosolutions.com",
  "paragon-dcx.com",
  "partech.com",
  "partners.braze.com",
  "passkit.com",
  "peak.ai",
  "phiture.com",
  "photon.in",
  "phrase.com",
  "phrasee.co",
  "pickaxe.ai",
  "piksel.com",
  "planning-inc.co.uk",
  "playable.video",
  "plinc.com",
  "pmweb.com.br",
  "possible.com",
  "powerdigitalmarketing.com",
  "powerweb.co.jp",
  "predictive.co.th",
  "producthackers.com",
  "productminds.io",
  "profusion.com",
  "project-a.com",
  "prolificinteractive.com",
  "prospa.com",
  "proximity.es",
  "proximitylondon.com",
  "publicis.com",
  "publicisgroupe.com",
  "publicisna.com",
  "publicissapient.com",
  "punchh.com",
  "punt.partners",
  "purplesquarecx.com",
  "pypestream.com",
  "quikly.com",
  "radar.com",
  "radar.io",
  "ragnaroknyc.com",
  "rapp.com",
  "razorfish.com",
  "readysetgo.design",
  "redpointglobal.com",
  "relationshipone.com",
  "relo.jp",
  "remerge.io",
  "reply.com",
  "reply.de",
  "revenuecat.com",
  "revenuepulse.com",
  "rexcollective.com",
  "rezultize.com",
  "rga.com",
  "rightpoint.com",
  "rocketfarmstudios.com",
  "rokkan.com",
  "rokt.com",
  "rplg.io",
  "rspective.pl",
  "rudderstack.com",
  "saatchi.com",
  "saatchi.hu",
  "saatchiny.com",
  "sageflo.com",
  "saleswingsapp.com",
  "scalero.io",
  "scdigital.co.jp",
  "schmack.co",
  "scuba.io",
  "segment.com",
  "sendbird.com",
  "sequra.com",
  "seriousbiscuit.co.uk",
  "servian.com",
  "setsailsoftware.com",
  "shawscott.com",
  "sheetlabs.com",
  "shiftparadigm.com",
  "shinelimited.co.nz",
  "shinsegae.com",
  "shopify.com",
  "simondata.com",
  "simpletechs.net",
  "singular.net",
  "sisudata.com",
  "sk.com",
  "slalom.com",
  "smartersends.com",
  "smartling.com",
  "smartscore.kr",
  "snowflake.com",
  "snowplow.io",
  "snowplowanalytics.com",
  "softcrylic.com",
  "softdebut.com",
  "sparkfly.com",
  "sparkplant.io",
  "spartapp.io",
  "sparx.cx",
  "speakdata.co.nz",
  "springbokagency.com",
  "springwoodlabs.co",
  "srijan.net",
  "stackedco.co",
  "stensul.com",
  "stitch.cx",
  "stitchtech.co",
  "stormideas.com",
  "strata-analytics.us",
  "stripo.email",
  "stuzo.com",
  "stylitics.com",
  "superglue.io",
  "survicate.com",
  "swyft.cx",
  "t-3.com",
  "t1a.com",
  "talon.one",
  "talon.one.com",
  "tapcxm.com",
  "taskus.com",
  "tbwa.com",
  "tealium.com",
  "teamitg.com",
  "tellius.com",
  "theemailstud.io",
  "thegrowthmarketerlondon.com",
  "thelumery.com",
  "themazegroup.com",
  "theneura.com",
  "thethreadteam.com",
  "thetradedesk.com",
  "thoughtspot.com",
  "thoughtworks.com",
  "thytarget.co.uk",
  "tinuiti.com",
  "tms-consulting.co.id",
  "toovio.com",
  "topdecileinc.com",
  "towa.at",
  "track.de",
  "trackddb.com",
  "trade.ec",
  "trans-cosmos.co.jp",
  "transcend.io",
  "transifex.com",
  "transparent.partners",
  "treasure-data.com",
  "trendlineinteractive.com",
  "tribalscale.com",
  "trustpilot.com",
  "tsworks.com",
  "tsworks.io",
  "twg.io",
  "twigeo.com",
  "twilio.com",
  "umac.co.kr",
  "unity3d.com",
  "unlockinggrowth.co",
  "unnest.co",
  "uplers.com",
  "uplers.in",
  "uptechstudio.com",
  "urbanpixels.com",
  "utilitynyc.com",
  "valtech.com",
  "vecton.pl",
  "venntifact.com",
  "verticurl.com",
  "verygood.ventures",
  "vibable.com",
  "vizbee.tv",
  "vml.com",
  "vmlyr.com",
  "vmlyrcommerce.com",
  "voucherify.io",
  "waug.com",
  "wavve.com",
  "wdmp.co.uk",
  "weare4c.com",
  "wearebarbarian.com",
  "wearehathway.com",
  "wearerival.com",
  "wearesilverbullet.com",
  "wearetaplondon.com",
  "whereoware.com",
  "wida-tech.com",
  "williamthomasdigital.com",
  "willowtreeapps.com",
  "winclap.com",
  "winstonfrancois.com",
  "wipro.com",
  "within.co",
  "within.co.kr",
  "wordofmouthcollective.com",
  "wsc-sports.com",
  "wunderkind.co",
  "wunderman.com",
  "wundermanthompson.com",
  "wundermobility.com",
  "wwt.com",
  "www.softdebut.com",
  "wyng.com",
  "wyoming-interactive.com",
  "ynd-consult.com",
  "ynd.co",
  "yodelmobile.com",
  "youknow.co.za",
  "zambo1.com",
  "zendesk.co",
  "zeotap.com",
  "zervizgroup.com",
]);

// Regular expression for validating an email
export const validEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

export const isValidEmail = (email?: string): boolean => {
  if (!email || !validEmailRegex.test(email)) {
    return false;
  }
  return true;
};

// Regular expression for restricted domains - edu, gov, mil
const restrictedDomainsPattern = /(\.mil|\.edu)(\.[a-z]{2})?$/i;

export const isRestrictedEmail = (email?: string): boolean => {
  if (!email) {
    return false;
  }
  email = email.toLowerCase();

  const domain = email.split("@")[1];
  if (!validEmailRegex.test(email) || restrictedDomainsPattern.test(email) || freeEmailProviders.has(domain)) {
    return true;
  }
  return false;
};

export const isCompetitorEmail = (email?: string): boolean => {
  if (!email) {
    return false;
  }
  email = email.toLowerCase();
  const domain = email.split("@")[1];
  return competitorDomains.has(domain);
};

export const isPartnerEmail = (email?: string): boolean => {
  if (!email) {
    return false;
  }
  email = email.toLowerCase();
  const domain = email.split("@")[1];
  return partnerDomains.has(domain);
};

export const isNonCompanyEmail = (email: string) => {
  return restrictedDomainsPattern.test(email);
};

export const isAllowedToContactSalesDomain = (email: string) =>
  isNonCompanyEmail(email) || isCompetitorEmail(email) || isPartnerEmail(email);
